export default {
    LoadBrandsSubscriptions: {
        datapoint: {
            name: 'LoadBrandsSubscriptions',
        },
    },
    UnsubscribeFromBrandSubscription: {
        datapoint: {
            name: 'UnsubscribeFromBrandSubscription',
        },
    },
};
//# sourceMappingURL=datapoints.js.map